import { useEffect, useState } from "react";
import { IUserShort } from "../../api/services/project.service";
import { ITeamMembership } from "../../api/services/team.service";
import { globalThemeStyles } from "../../constants/globalStyles";
import MemberList from "./MemberList";
import UserCombobox from "./UserCombobox";

export default function UserMembershipSection({
  currentMembers,
  allUsers,
  fetchCurrentMembers,
  removeMember,
  addMember,
}: {
  currentMembers: ITeamMembership[];
  allUsers: IUserShort[];
  fetchCurrentMembers: () => void;
  removeMember: (userId: string) => void;
  addMember: (userId: string, teamRole: string) => void;
}) {
  const [selectedUser, setSelectedUser] = useState<IUserShort | null>(null);
  const [teamRole, setTeamRole] = useState<string>("GUEST");

  useEffect(() => {
    if (selectedUser) {
      addMember(selectedUser.id, teamRole);
    }
  }, [selectedUser]);

  return (
    <div className="flex flex-col rounded-md pb-2">
      <span className="text-slate-500 dark:text-slate-400 text-sm">
        {
          "Select an artist that you have previously worked with or invite them by email"
        }
      </span>
      <div className="flex flex-col justify-center mt-4 space-y-4">
        <select
          disabled={false}
          value={teamRole}
          onChange={(e) => setTeamRole(e.target.value)}
          className={`mt-3 text-sm shadow-md block w-full p-2.5 disabled:cursor-not-allowed ${globalThemeStyles.inputbox}`}
        >
          <option value="GUEST">GUEST</option>
          <option value="MEMBER">MEMBER</option>
          <option value="OWNER">OWNER</option>
        </select>
        <div className="flex justify-center">
          <div className="flex-grow">
            <UserCombobox
              users={allUsers.filter(
                (user) =>
                  currentMembers.find((mem) => mem.userId === user.id) ===
                  undefined
              )}
              selected={selectedUser}
              setSelected={setSelectedUser}
            />
          </div>
        </div>
      </div>
      <div className="mt-4">
        <MemberList users={currentMembers} deleteUser={removeMember} />
      </div>
    </div>
  );
}
